"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Plottable = _interopRequireWildcard(require("plottable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * This is a helper for configuring a Plottable XYPlot component. It is mutative.
 * Relies on the implicit assumption that a series "value" accessor will be available
 * on the metadata of the dataset (see the "setXYPlotData" data helper).
 */
var configureXYPlot = function configureXYPlot(_ref, plot) {
  var isAxisInverted = _ref.isAxisInverted,
    disableAutorangeMode = _ref.disableAutorangeMode,
    xScale = _ref.xScale,
    yScale = _ref.yScale,
    xValue = _ref.xValue;
  var lightStrokeWidth = 1;
  var strongStrokeWidth = 3;
  plot.attr(plot instanceof Plottable.Plots.Line ? 'stroke' : 'fill', function (d, index, dataset) {
    return dataset.metadata().color;
  });
  if (plot instanceof Plottable.Plots.Line) {
    plot.attr('stroke-width', function (d, index, dataset) {
      return dataset.metadata().isFocused ? strongStrokeWidth : lightStrokeWidth;
    });
  }
  return isAxisInverted ? plot.y(function (d) {
    return xValue(d);
  }, xScale).x(function (d, index, dataset) {
    return dataset.metadata().value(d);
  }, yScale).autorangeMode(disableAutorangeMode ? 'none' : 'x') : plot.x(function (d) {
    return xValue(d);
  }, xScale).y(function (d, index, dataset) {
    return dataset.metadata().value(d);
  }, yScale).autorangeMode(disableAutorangeMode ? 'none' : 'y');
};
var _default = exports["default"] = configureXYPlot;
//# sourceMappingURL=configureXYPlot.js.map